import { firebaseDefault, firebaseFacebook, firebaseFail, firebaseGoogle } from './firebaseSlice'
import { startLoginFirebase } from '..'
/* services */
import { signInWithFacebook, signInWithGoogle } from '@services'

export const startLoginGoogle = (navigate: any) => {
    return async (dispatch: any) => {
        const response = (await signInWithGoogle()) as any

        if (!response.ok) {
            return dispatch(firebaseFail(response))}

        const { _tokenResponse: _firebase } = response.result

        const { email, firstName, lastName, idToken } = _firebase

        dispatch(startLoginFirebase(idToken, navigate))

        dispatch(firebaseGoogle({ email, firstName, lastName, idToken }))

        //setTimeout(() => navigate('/home'), 500)
    }
}

export const startLoginFacebook = (navigate: any) => {
    return async (dispatch: any) => {
        const response = (await signInWithFacebook()) as any

        if (!response.ok) {
            return dispatch(firebaseFail(response))}

        const { _tokenResponse: _firebase } = response.result

        const { email, firstName, lastName, idToken } = _firebase

        dispatch(startLoginFirebase(idToken, navigate))

        dispatch(firebaseFacebook({ email, firstName, lastName, idToken }))

        //setTimeout(() => navigate('/home'), 500)
    }
}

export const loginDefaultFirebase = () => {
    return async (dispatch: any) => {
        dispatch(firebaseDefault())
    }
}
